module.exports = __webpack_public_path__ + "img/icon_zhichiduoyewu.216e7e34.png";